import React from 'react';
import { getRulesBulkOutcomes } from 'selectors/bulkOutcomes';
import { useSelector } from 'store';
import OutcomesRuleItem from './OutcomesRuleItem';

const RulesList: React.FC = () => {
  const ruleCategories = useSelector(getRulesBulkOutcomes);

  return (
    <div className="h-full flex flex-col gap-6">
      {ruleCategories.map((r) => (
        <OutcomesRuleItem key={r.rule.uuid} rule={r.rule} revisionId={r.rule_revision_uuid} />
      ))}
    </div>
  );
};

export default RulesList;
